import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent {
  @Input() disabledSubmit: boolean = false;
  @Input() title: string = '';
  @Input() submitText: string = this.translate.instant('submit');
  @Input() cancelText: string = this.translate.instant('cancel');
  @Input() hasSubmitButton: boolean = true;

  @Output() handleOnSubmit: EventEmitter<any> = new EventEmitter();

  constructor(private modalRef: BsModalRef, private translate: TranslateService) {}

  confirm(): void {
    this.handleOnSubmit.emit();
  }

  decline(): void {
    this.modalRef.hide();
  }
}
